import React, { PropsWithChildren } from "react";
import { Route, RouteProps } from "react-router-dom";
import useIsInRoles from "../hooks/use-is-in-roles";
import { Roles } from "../roles/types";
import NoAutorizado from "./no-autorizado";

type EntaPrivateRoute = {
  roles?: Roles[];
} & RouteProps;

const PrivateContent: React.FC<PropsWithChildren<{ roles?: Roles[] }>> = ({
  children,
  roles,
}) => {
  const isInRoles = useIsInRoles();
  const autorized = isInRoles(roles);

  if (autorized) return <>{children}</>;
  return <NoAutorizado />;
};

const PrivateRouteInner: React.FC<PropsWithChildren<{ roles?: Roles[] }>> = ({
  children,
  roles,
}) => {
  return <PrivateContent roles={roles}>{children}</PrivateContent>;
};

const PrivateRoute: React.FC<PropsWithChildren<EntaPrivateRoute>> = ({
  children,
  roles,
  ...rest
}) => {
  return (
    <Route {...rest}>
      <PrivateRouteInner roles={roles}>{children}</PrivateRouteInner>
    </Route>
  );
};

export default PrivateRoute;
